<template>
  <VDialog width="500" v-model="dialog">
    <VCard>
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle>{{ $t("productCode") }}</VCardTitle>
      <VCardText>
        <ValidationObserver ref="formObs" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <CustomInputText
              ref="inputRef"
              autofocus
              v-model="accountCode.accountingCode"
              :name="$t('productCode')"
              class="user_input"
              rules="required"
            ></CustomInputText>
            <div class="text-right pt-5">
              <VBtn :type="submit" color="primary" :disabled="loading">{{
                $t("send")
              }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
const ACCOUNT_CODE = {
  partitionId: null,
  accountingCode: null,
};
export default {
  name: "AccountCodeLotDialog",
  data() {
    return {
      dialog: false,
      loading: false,
      accountCode: {
        ...ACCOUNT_CODE,
      },
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        const { formObs } = this.$refs;
        this.accountCode = {
          ...ACCOUNT_CODE,
        };
        if (formObs) formObs.reset();
      }
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        await this.$http.post("partition/accounting-code", this.accountCode);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.close();
        this.$emit("UPDATED");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    open(accountCode) {
      this.dialog = true;
      this.accountCode = accountCode;
      this.$nextTick(() => {
        this.$refs.inputRef.focus();
      });
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
